module.exports = __webpack_public_path__ + "static/Banner-37-4eb4fc1bb78f9a7854c9099d583ee791.png";